import React from 'react'
import './Video.css'
import { Link } from 'react-router-dom';
import video_one from './video/kk1.mp4';
import video_two from './video/kk2.mp4';
import video_free from './video/kk3.mp4';
import video_foo from './video/kk4.mp4';
import AA from '../Image/AA.png';
import { useState, useEffect } from "react";
import { FaAngleUp } from "react-icons/fa";

function Videos() {

    const [showTopBtn, setShowTopBtn] = useState(false);
    useEffect(() => {
        window.addEventListener("scroll", () => {
            if (window.scrollY > 400) {
                setShowTopBtn(true);
            } else {
                setShowTopBtn(false);
            }
        });
    }, []);

    const goToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    };

    return (
        <div className='container_videos'>

            {/* Стрелка вверх */}
            <div className="top-to-btm">
                {" "}
                {showTopBtn && (
                    <FaAngleUp
                        className="icon-position icon-style"
                        onClick={goToTop}
                    />
                )}{" "}
            </div>


            <div className='dysplay_videos'>

                <div className='text_videos'>
                    <p className='text_videos_p'>Freelance3359</p>
                </div>

                <div className='menu_videos'>
                    <div className='block__videos_a_href'>

                        <a href="#" className="button">
                            <div className="button__line"></div>
                            <div className="button__line"></div>
                            <Link component={Link} to="/Portfolio" className="button__text">Все видео</Link>
                            <div className="button__drow1"></div>
                            <div className="button__drow2"></div>
                        </a>

                        <a href="#" className="button">
                            <div className="button__line"></div>
                            <div className="button__line"></div>
                            <Link component={Link} to="/" className="button__text">Шаг назад</Link>
                            <div className="button__drow1"></div>
                            <div className="button__drow2"></div>
                        </a>

                    </div>
                </div>
            </div>

            <div className='dysplay_videos'>

                <div className='h1_videos'>

                    <h1 className='videoPortfolio_videos'>Видео портфолио.</h1>

                    <div className='icons__videos'>
                        <img className='h1_videos_image_image' width="100" height="100" src="https://media.discordapp.net/attachments/1047046814672629820/1077740470404399135/AGF-l7_Mh-fkAio3bmX9_IuvwXn9Pk7W80poTNt9tgs900-c-k-c0xffffffff-no-rj-mo.png?width=683&height=683" alt="" />
                        <img className='h1_videos_image h1_icons_margin_videos' width="100" height="100" src="https://media.discordapp.net/attachments/1047046814672629820/1077740898802217110/202818_normal.png?width=683&height=683" alt="" />
                        <img className='h1_videos_image h1_icons_margin_videos' width="100" height="100" src="https://media.discordapp.net/attachments/1047046814672629820/1077741334917546004/premiere-cc.png?width=700&height=683" alt="" />
                        <img className='h1_videos_image h1_icons_margin_videos' width="100" height="100" src="https://media.discordapp.net/attachments/1047046814672629820/1085558736371847178/0xm0jXZIkRwpxVX8ok3_RGS-45LflXza2ey1D91x9e6eBJ3cEruJOftKhoQnt_DpVbTlrEJqRxuiCm8MflFRHlZT.png" alt="" />
                    </div>
                </div>

                {/* Кнопка */}
                <div className='button__text__none_videos'>
                    <div className='button__text_videos'>
                        <Link component={Link} to="/Portfolio" className="glow-on-hover_videos">Все видео</Link>
                    </div>

                    <div className='button__text_videos'>
                        <Link component={Link} to="/" className="glow-on-hover_videos">Шаг назад</Link>
                    </div>
                </div>


                <div className='img__videos_dysplay'>
                    <img src={AA} alt="" className='img__videos'></img>
                </div>

            </div>

            {/* Стрелка */}
            <div className='imageblock_videos'>
                <a href="#videos_one" className="arrow-container">
                    <div className="arrow"></div>
                    <div className="arrow"></div>
                    <div className="arrow"></div>
                </a>
            </div>

            <div id='videos_one'></div>
            <div className='text_videos_pp'>
                <p className='text_videos_ppp'>Я Сарычев Алексей, занимаюсь short видео, видео на Youtube, обрезкой, монтажем, звуком, анимацией разных видео.</p>
            </div>

            {/* Стрелка */}
            <div className='imageblock_videos'>
                <a href="#videos_two" className="arrow-container">
                    <div className="arrow"></div>
                    <div className="arrow"></div>
                    <div className="arrow"></div>
                </a>
            </div>


            <div className='portfolio_videos' id='videos_two'>
                <h2 className='portfolio_text_videos_two'>Пример портфолио</h2>
            </div>

            <div className='portfolio_text_block_videos_one_block_dysplay'>
                <div className='portfolio_text_block_videos_one_block_dysplay_media912'>
                    <video className='portfolio_text_block_videos_one videos_one_margin box__videos' controls="controls" >
                        <source src={video_one} type="video/mp4" /> </video>
                    <video className='portfolio_text_block_videos_two videos_one_margin videos_one_margin box__videos' controls="controls">
                        <source src={video_two} type="video/mp4" /> </video>
                </div>
                <div className='portfolio_text_block_videos_one_block_dysplay_media912'>
                    <video className='portfolio_text_block_videos_free videos_one_margin videos_one_margin box__videos' controls="controls">
                        <source src={video_free} type="video/mp4" /> </video>
                    <video className='portfolio_text_block_videos_foo videos_one_margin videos_one_margin box__videos' controls="controls">
                        <source src={video_foo} type="video/mp4" /> </video>
                </div>

            </div>

            <div className='portfolio_videos'>
                <h2 className='portfolio_text_videos_two'>Мои контакты</h2>
            </div>

            {/* Кнопка */}
            <div className='button__text_videos'>
                <a href="https://tele.click/{Freelance3359}" className="glow-on-hover_videos">Телеграмм</a>
            </div>

        </div >
    )
}

export default Videos;
